import * as React from 'react';
import styled from 'styled-components';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';

// Takes the backgroundColor from the primary button styles, and applies
// it as the color for this text link button.
// Default values of font-size and color are taken from `nth-block-button`
const Button = styled.button<{
  s: {
    buttonStyleDefault: React.CSSProperties;
    buttonStyleHover: React.CSSProperties;
  };
}>(({ s: { buttonStyleDefault, buttonStyleHover } }) => ({
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '0.875rem',
  ...buttonStyleDefault,
  color: buttonStyleDefault ? buttonStyleDefault.backgroundColor : '#2b7cac',
  background: 'none',
  border: 'none',
  '&:hover': {
    ...buttonStyleHover,
    color: buttonStyleHover ? buttonStyleHover.backgroundColor : '#286090',
    background: 'none',
    border: 'none',
  },
}));

interface TextLinkProps {
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

// This is a temporary replacement for `nth-text-link`. It's being replaced because:
// 1) This will need `type` set to button so that it doesn't submit the form. Can't set type on `nth-text-link`
// 2) This should probably have some padding on mobile to make it easier to tap. Can't set padding on `nth-text-link`
// 3) `nth-text-link` doesn't have theming. It seems the text should be set to the primary button color. This
//    component doesn't solve for theming well, but noting it anyway since it will have to be addressed at some point
const TextLink: React.FunctionComponent<TextLinkProps> = ({
  children,
  onClick,
}) => {
  const {
    buttonsPrimaryDefault: buttonStyleDefault,
    buttonsPrimaryHover: buttonStyleHover,
  } = useTheme();

  return (
    <Button
      type="button"
      s={{
        buttonStyleDefault,
        buttonStyleHover,
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default withThemeProvider(TextLink, {
  themeTokens: ['buttonsPrimaryDefault', 'buttonsPrimaryHover'],
});
